import { Observable, throwError } from 'rxjs';

import { DataStoreOptions } from '@skinsoft/data-store';
import { EntityDataStore } from '@skinsoft/entity-data-store';
import { TranslatedString } from '@skinsoft/i18n';

declare const FALLBACK_LOCALE;

export interface Workspace {
    id: string;
    name: TranslatedString;
}

export class WorkspaceDataStore extends EntityDataStore<Workspace> {
    public static getInstance() {
        if (!WorkspaceDataStore.instance) {
            WorkspaceDataStore.instance = new WorkspaceDataStore();
        }

        return WorkspaceDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$workspaceDataStore = WorkspaceDataStore.getInstance();
    }

    private static instance: WorkspaceDataStore = null as any;

    constructor() {
        super('workspace');
    }

    public update(id: string, body: Partial<Workspace>, endpointOverride?: string) {
        return throwError("Cannot update workspace")
    }

    public searchAll(queryText: string | null, sortObject: any, pageSize: number = 15, types?: string[], page: number = 0, advancedSearches: any = null, filteredIds?: string[], pathAndValueToCheck?: any, searchEndpointOverride: string | null = null, options: DataStoreOptions = {}) {
        return throwError("Cannot search workspaces")
    }

    public searchOneWithText(queryText: string, types: string[]): Promise<Workspace> {
        throw new Error("Cannot search workspaces")
    }

    public searchTitles(types: string[], filterText: string, pageNumber: number = 0, defaultFilter: string = "", size: number = 10, filterIds?: string[], esPath?: any, language: string = FALLBACK_LOCALE) {
        return throwError("Cannot search workspaces")

    }

    public create(createBody?: Partial<Workspace>, body?: Partial<Workspace>): Observable<Workspace> {
        return throwError("Cannot create workspaces")
    }

    public duplicate(entityToDuplicateId: string, createBody?: Partial<Workspace>, body?: Partial<Workspace>) {
        return throwError("Cannot duplicate workspace")
    }

    public delete(id: string) {
        return throwError("Cannot delete workspace")
    }

}
